import { login, getInfo, getRsa } from '@/api/login'
import router, { resetRouter } from '@/router'
import md5 from 'js-md5';
import { AesEncode, AesDecode } from '../../utils/encryptAes'
import { isPC } from "@/utils/browser";
import {Message} from "element-ui";


const state = {
  token: localStorage.getItem('b_token') ? localStorage.getItem('b_token') : '', // 认证凭证'
  userName: '',
  userId: '',
  roles: [],
  permissionList: [], // 按钮级别的权限
  introduce: '',
  showStatus: false,
  agency: {}, // 添加产品推荐-添加dialog中对应的设备账号
  custom: {}, // 添加产品推荐-添加dialog中对应的客户名称
  name: '', //右上角用户登录后显示的用户名
  version: '', // 版本信息
  targetid: null, // 目标id，默认67
}
const mutations = {
  SET_TOKEN(state, val) {
    state.token = val
    localStorage.setItem('b_token', val)
  },
  DEL_TOKEN(state) {
    state.token = ''
    state.userName = ''
    state.userId = ''
    state.roles = ''
    state.permissionList = ''
    state.introduce = ''
    state.showStatus = false
    localStorage.removeItem('b_token')
    localStorage.removeItem('routes')
  },
  SET_ROLES(state, payload) {
    state.roles = payload
  },
  SET_PERMISSIONLIST(state, payload) {
    state.permissionList = payload
  },
  SET_USR_ID(state, payload) {
    state.userId = payload
  },
  SET_NAME(state, payload) {
    state.userName = payload
  },
  SET_LOGIN_NAME(state, payload) {
    state.name = payload
  },
  SET_INTRODUCE(state, payload) {
    state.introduce = payload
  },
  SET_SHOW_STATUS(state, payload) {
    state.showStatus = payload
  },
  SET_AGENCY(state, payload) {
    state.agency = payload
  },
  SET_CUSTOM(state, payload) {
    state.custom = payload
  },
  SET_VERSION(state, payload) {
    state.version = payload
  },
  SET_TARGET_ID(state, payload) {
    state.targetid = payload
  },
}

const actions = {
  _login({ commit }, formdatas) {
    return new Promise((resolve, reject) => {
      if(formdatas.password !== undefined) {
        formdatas.user_name = formdatas.username;
        formdatas.password = AesEncode(formdatas.password)
        delete formdatas.username
      }
      const proId = isPC()? 6 : 7; // pc端
      formdatas.project_id = proId; // 门户对应的是6


      // 此处要更新登录接口
      login(formdatas).then(res => {
        if (res.code === 2000 ) {
          commit('SET_TOKEN', res.data.access_token)
          resolve(res)
        }else{
          reject(res.msg)
        }
      }).catch(error => {
        reject(error)
      })

    })
  },
  loginOut({ commit }) {
    commit('DEL_TOKEN')
    router.replace('/login')
  },
  _getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(res => {
          if (res.code === 2000) {
            const roles = res.data.Roles;
            const permissions = res.data.PermissionList;
            const name = res.data.UserInfo && res.data.UserInfo.user_name;
            commit('SET_ROLES', roles)
            commit('SET_PERMISSIONLIST', permissions); // 按钮级别的权限
            // const { name, roles,introduce, show_status, agency, custom, id, username, version } = res.data
            //
            // commit('SET_ROLES', roles)
            // commit('SET_USR_ID', id)
            commit('SET_NAME', name)
            // commit('SET_LOGIN_NAME', username)
            // commit('SET_INTRODUCE', introduce)
            // commit('SET_SHOW_STATUS', show_status)
            // commit('SET_AGENCY', agency)
            // commit('SET_CUSTOM', custom)
            // commit('SET_VERSION', version)

          } else {
            router.replace({
              path: '/login',
              query: {
                redirect: '/'
              }
            })
          }
          resolve(res)
        })
      .catch(error => {
        // 如果是401错误，让axios拦截器处理，这里不显示错误信息
        if (error.response && error.response.status === 401) {
          return Promise.reject(error)
        }
        Message.error(error.msg || error.message || '获取用户信息失败')
        return Promise.reject(error)
      })
    })
  },
  _getRsa({ commit }, params) {
    return new Promise((resolve, reject) => {
      getRsa(params).then(res => {
        if (res.code === 2000 ) {
          commit('SET_TOKEN', res.data.access_token)
        } else {
          router.replace({
            path: '/login',
            query: {
              redirect: '/'
            }
          })
        }
        resolve(res)
      }).catch(error => {
        Message.error(error.msg)
      })
    })
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}